import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import ReactDatetime from "react-datetime";
import { Calendar, Time } from "../../common/imagePath";
import moment from "moment";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
  AWS_IMAGE_FOLDER_STORECONFIG,
  AWS_IMAGE_FOLDER_ECOMCONFIG,
} from "../../common/Constant";
import { uploadAWS } from "../../common/AWSHelper";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";

import { Noimage } from "../../common/imagePath";

import { MenuItem } from "@mui/material";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function Deals({ searchQuery }) {
  const [visibleDeals, setVisibleDeals] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("MM-DD-YYYY"));
  const [endDate, setEndDate] = useState(moment().format("MM-DD-YYYY"));
  const [publishedDate, setPublishedDate] = useState(
    moment().format("MM-DD-YYYY")
  );
  const [selectedImage, setSelectedImage] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  // let deleteConfirmationPoupIdName = "DeleteNewsLetterConfirmationModal";

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //For Image
  const vaidation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type, index) => {
    setBtnLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_ECOMCONFIG, (data) => {
      if (data) {
        if (type === "Images") {
          setImageUrl(data);

          setLoading(false);
        }
      }
    });
  };

  const handleImageUpload = (event, index) => {
    setChangeImagename(true);

    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFile(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          setPreviewImage(images);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };
  //For Image
  //For Start Date
  const handleStartDate = (momentDate) => {
    setStartDate(moment(momentDate).format("MM-DD-YYYY"));
  };

  //For End Date
  const handleEndDate = (event, momentDate) => {
    setEndDate(moment(momentDate).format("MM-DD-YYYY"));
    // const { name, value } = event.target;
    // setFormValues({
    //   ...formValues,
    //   endDate: moment(momentDate).format("MM-DD-YYYY"),
    // });
  };

  //For Published Date
  const handlePublishedDate = (momentDate) => {
    setPublishedDate(moment(momentDate).format("MM-DD-YYYY"));
  };

  // Form Values
  const [formValues, setFormValues] = useState({
    Title: "",
    Description: "",
    WritersName: "",
    ButtonLink: "",
    IsActive: "",
  });
  // Form Values

  //HandleDelete
  // const handleDeletePopup = (pID3) => {
  //   const deleteRequestParam = {
  //     ID: pID3,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (id, rows, field) => {
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      ID: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = { ID: 0, Name: "" };
    setFormValues(clearData);
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size:"10",
    },
    {
      header: "Title",
      accessorKey: "Title",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
    {
      header: "Button Link",
      accessorKey: "ButtonLink",
    },
    {
      header: "Writers Name",
      accessorKey: "WritersName",
    },
    {
      header: "Is Active",
      accessorKey: "IsActive",
      size:"10",
    },
    {
      header: "Start Date",
      accessorKey: "StartDate",
      size:"10",
      Cell: ({ row }) => moment(row.original.StartDate).format("MM/DD/YYYY "),
    },
    {
      header: "End Date",
      accessorKey: "EndDate",
      size:"10",
      Cell: ({ row }) => moment(row.original.EndDate).format("MM/DD/YYYY "),
    },
    {
      header: "Published Date",
      accessorKey: "PublishedDate",
      size:"10",
      Cell: ({ row }) =>
        moment(row.original.PublishedDate).format("MM/DD/YYYY "),
    },
    {
      header: "Images",
      accessorKey: "ImageUrl",
      cell: ({ row }) => (
        <>
          {/* <Link to={row.original.Image} target="_blank"> */}
            <img
              // src={row.original.Image}
              alt="Selected Image"
              style={{
                maxWidth: "50px",
                maxHeight: "50px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            />
          {/* </Link> */}
        </>
      ),
    },
  ]);

  //TableData Columns

  //HandleSubmit For the Form
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      ID: 0,
      Title: formValues.Title,
      Description: formValues.Description,
      ButtonLink: formValues.ButtonLink,
      WritersName: formValues.WritersName,
      Image: ImageUrl,
      IsActive: formValues.IsActive,
      PublishedDate: moment(publishedDate).format("YYYY-MM-DD"),
      StartDate: moment(startDate).format("YYYY-MM-DD"),
      EndDate: moment(endDate).format("YYYY-MM-DD"),
      LoginUserId: Id,
    };
    setLoading(true);
    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/newsletterupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setLoading(true);
          window.location.reload();
          // navigate("/suppliers");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
      });
  };
  //HandleSubmit For the Form

  //OnChange For Input Fields
  const handleChange = (event, fieldName) => {
    if (fieldName === "IsActive") {
      setFormValues({
        ...formValues,
        [fieldName]: event.target.checked ? 1 : 0,
      });
    } else {
      const { name, value } = event.target;
      setFormValues({ ...formValues, [name]: value });
    }
  };

  //OnChange For Input Fields

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.ecommconfigBaseUrl}/ecomconfig/newsletterselect`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTableData(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: "Title",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Insert Title Of The Banner"
            name="Title"
            onChange={handleChange}
            value={formValues.Title}
          />
        </>
      ),
    },
    {
      name: "Description",
      input: (
        <>
          <input
            className="form-control form-control-sm ml-2"
            placeholder="Insert Description Of The Banner"
            name="Description"
            onChange={handleChange}
            value={formValues.Description}
          />
        </>
      ),
    },
    {
      name: "Button Link",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Button Link..."
            name="ButtonLink"
            onChange={handleChange}
            value={formValues.ButtonLink}
          />
        </>
      ),
    },
    {
      name: "Writers Name",
      input: (
        <input
          className="form-control form-control-sm ml-2"
          placeholder="Enter Writers Name"
          name="WritersName"
          onChange={handleChange}
          value={formValues.WritersName}
        />
      ),
    },
    {
      name: "Publish Date",
      input: (
        <>
          <div className="col-md-8 ">
            <div className="input-group">
              <span className="input-group-text" id="basic-addon1">
                <img src={Calendar} alt="img" />
              </span>
              <div style={{ width: "100%" }}>
                <ReactDatetime
                  value={publishedDate}
                  onChange={handlePublishedDate}
                  id="EndDate"
                  name="EndDate"
                  dateFormat="MM-DD-YYYY"
                  timeFormat={false}
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Image",
      input: (
        <>
          <div className="row">
            <div className="col-md-11">
              <input
                type="file"
                class="form-control form-control-sm ml-2"
                id="inputGroupFile03"
                accept="image/*"
                aria-describedby="inputGroupFileAddon03"
                multiple
                onChange={handleImageUpload}
                aria-label="Upload"
                name="Images"
              ></input>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-10">
              <div
                className={`${
                  ImageUrl ? "" : selectedImage ? "" : "d-none"
                } form-group row`}
              >
                <label className="col-form-label col-md-2 form-label"></label>
                <div className="col-md-10">
                  <img
                    src={`${ImageUrl ? ImageUrl : selectedImage}`}
                    alt="Item_Image"
                    className="ItemImage w-25 h-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "IsActive",
      input: (
        <>
          <input
            class="form-check-input ms-1"
            type="checkbox"
            id="flexSwitchCheckDefault"
            name="IsActive"
            onChange={(event) => handleChange(event, "IsActive")}
            checked={formValues.IsActive === 1}
          />
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <Fragment>
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => setVisibleDeals(!visibleDeals)}
              >
                News Letter
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleDeals}>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div
                  className="container"
                  style={{
                    textAlign: "center",
                    // backgroundColor: "blanchedalmond",
                    border: "1px solid rgba(0,0,0,.12)",
                  }}
                >
                  <div className="row mb-3 pt-3">
                    <div className="col-md-11 mt">
                      <div className="row">
                        <div
                          // className="col-md-2"
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gap: "20px",
                          }}
                        >
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    textAlign: "left",
                                    alignItems: "center",
                                  }}
                                >       
                                  <label
                                    className=" pull-left"
                                    style={{ fontSize: "15px" }}
                                  >
                                    {el.name}
                                  </label>
                                  <div className="col-md-10 text-left">
                                    {el.input}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="col-md-10"></div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-sm btn-primary mb-3">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
                <MaterialReactTable
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  columns={columns}
                  data={tableData}
                  enableRowActions
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      className="confirm-text"
                      to="#"
                      // key="delete"
                      title="Delete"
                      data-bs-toggle="modal"
                      // data-bs-target="#DeleteConfirmationModal"
                      onClick={() => handleDeletePopup(row.original.ID, "", "")}
                    >
                      {/* <DeleteIcon /> */}
                      Delete
                    </MenuItem>,
                  ]}
                />
              </div>
            </div>
          </CCollapse>
        </div>
      ) : (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink onClick={() => setVisibleDeals(!visibleDeals)}>
                News Letter
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleDeals}>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div
                  className="container"
                  style={{
                    textAlign: "center",
                    // backgroundColor: "blanchedalmond",
                    border: "1px solid rgba(0,0,0,.12)",
                  }}
                >
                  <div className="row mb-3 pt-3">
                    <div className="col-md-11">
                      <div className="row">
                        <div
                          // className="col-md-2"
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gap: "10px",
                            padding: "10px",
                          }}
                        >
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <label
                                    className="mt-1 pull-left w-50"
                                    style={{
                                      fontSize: "15px",
                                      minWidth: "100px!important",
                                    }}
                                  >
                                    {el.name}
                                  </label>
                                  <div className="col-md-10 text-left">
                                    {el.input}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        <div className="col-md-10"></div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary mb-3"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
                <DataTable
                  title="News Letter"
                  columns={columns}
                  data={tableData}
                  progressPending={loading}
                  pagination
                  paginationServer
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  fixedHeader
                  persistTableHead
                  sortServer
                />
              </div>
            </div>
          </CCollapse>
        </div>
      )}

      <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/newsletterdelete`}
        // idname={deleteConfirmationPoupIdName}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </Fragment>
  );
}

export default Deals;
